module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Connector Settings</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel\" style=\"width: 155px;\">Line Style</label>\r\n        <div>  \r\n            <select name=\"lineType\" id=\"lineType\">\r\n                <option value=\"straight\">Straight</option>\r\n                <option value=\"curved\">Curved</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel\" style=\"width: 155px;\">Caption Box Width</label>\r\n        <div>\r\n            <input type=\"text\" name=\"textBoxWidth\" value=\"")
    ; __append(escapeFn(textBoxWidth))
    ; __append("\" style=\"width:50px;\"> px\r\n        </div> \r\n    </div> \r\n</div>")
  }
  return __output;

}